import { defineMessages } from 'react-intl';

/** The Studio song picker (design release-kit t1, t1b, t1c). */
export const songPickerMessages = defineMessages({
  subtitle: {
    id: 'app.sml.promote.studio.picker.subtitle',
    defaultMessage: "Everything you make follows the song's theme: its colours, its fonts, its feel.",
  },
  find: { id: 'app.sml.promote.studio.picker.find', defaultMessage: 'Find a song' },
  noMatch: { id: 'app.sml.promote.studio.picker.noMatch', defaultMessage: 'No song matches "{query}".' },
  groupComingOut: { id: 'app.sml.promote.studio.picker.group.comingOut', defaultMessage: 'Coming out' },
  groupComingOutSub: { id: 'app.sml.promote.studio.picker.group.comingOutSub', defaultMessage: 'The nearest first' },
  groupOutNow: { id: 'app.sml.promote.studio.picker.group.outNow', defaultMessage: 'Out now' },
  groupOutNowSub: { id: 'app.sml.promote.studio.picker.group.outNowSub', defaultMessage: 'The newest first' },

  heroAria: { id: 'app.sml.promote.studio.picker.heroAria', defaultMessage: 'Make something for {title}' },
  themeDefault: { id: 'app.sml.promote.studio.picker.themeDefault', defaultMessage: '{theme} · default' },
  whenToGo: {
    id: 'app.sml.promote.studio.picker.when.toGo',
    defaultMessage: '{days, plural, one {day} other {days}} to go',
  },
  whenOutDays: {
    id: 'app.sml.promote.studio.picker.when.outDays',
    defaultMessage: '{days, plural, one {day} other {days}} out',
  },
  whenToday: { id: 'app.sml.promote.studio.picker.when.today', defaultMessage: 'Today' },
  whenYears: { id: 'app.sml.promote.studio.picker.when.years', defaultMessage: '{years} yr' },
  whenOut: { id: 'app.sml.promote.studio.picker.when.out', defaultMessage: 'out' },
  artistOut: { id: 'app.sml.promote.studio.picker.artistOut', defaultMessage: '{artist} · Out {date}' },
  artistNoDate: { id: 'app.sml.promote.studio.picker.artistNoDate', defaultMessage: '{artist} · No date yet' },

  factMaster: { id: 'app.sml.promote.studio.picker.fact.master', defaultMessage: '✓ Master' },
  factNoMaster: { id: 'app.sml.promote.studio.picker.fact.noMaster', defaultMessage: 'No master' },
  factMasterProcessing: {
    id: 'app.sml.promote.studio.picker.fact.masterProcessing',
    defaultMessage: 'Master processing',
  },
  factMasterFailed: { id: 'app.sml.promote.studio.picker.fact.masterFailed', defaultMessage: 'Master failed' },
  factLyricsSynced: { id: 'app.sml.promote.studio.picker.fact.lyricsSynced', defaultMessage: '✓ Lyrics synced' },
  factLyricsSyncing: { id: 'app.sml.promote.studio.picker.fact.lyricsSyncing', defaultMessage: 'Lyrics syncing' },
  factLyrics: { id: 'app.sml.promote.studio.picker.fact.lyrics', defaultMessage: 'Lyrics' },
  factNoLyrics: { id: 'app.sml.promote.studio.picker.fact.noLyrics', defaultMessage: 'No lyrics' },
  factPreSaveLive: { id: 'app.sml.promote.studio.picker.fact.preSaveLive', defaultMessage: 'Pre-save live' },
  factNoPreSave: { id: 'app.sml.promote.studio.picker.fact.noPreSave', defaultMessage: 'No pre-save' },
  factReleased: { id: 'app.sml.promote.studio.picker.fact.released', defaultMessage: 'Released' },

  madeNothing: { id: 'app.sml.promote.studio.picker.made.nothing', defaultMessage: 'Nothing made yet' },
  madeReady: { id: 'app.sml.promote.studio.picker.made.ready', defaultMessage: '{count} ready' },
  madeWorking: { id: 'app.sml.promote.studio.picker.made.working', defaultMessage: '{count} working' },
  madeFailed: { id: 'app.sml.promote.studio.picker.made.failed', defaultMessage: '{count} failed' },

  nextNoMaster: { id: 'app.sml.promote.studio.picker.next.noMaster', defaultMessage: 'Next up · no master needed' },
  nextBeforeRelease: {
    id: 'app.sml.promote.studio.picker.next.beforeRelease',
    defaultMessage: 'Next up · before the release',
  },
  nextOutNow: { id: 'app.sml.promote.studio.picker.next.outNow', defaultMessage: 'Next up · out now' },
  nextCatalog: { id: 'app.sml.promote.studio.picker.next.catalog', defaultMessage: 'Next up · catalog' },
  chipAnnouncePost: { id: 'app.sml.promote.studio.picker.chip.announcePost', defaultMessage: 'Announce post' },
  chipPreSaveStory: { id: 'app.sml.promote.studio.picker.chip.preSaveStory', defaultMessage: 'Pre-save story' },
  chipOutNowStory: { id: 'app.sml.promote.studio.picker.chip.outNowStory', defaultMessage: 'Out now story' },
  costFree: { id: 'app.sml.promote.studio.picker.cost.free', defaultMessage: 'FREE' },
  costCredits: { id: 'app.sml.promote.studio.picker.cost.credits', defaultMessage: '{credits} CR' },

  makeSomething: { id: 'app.sml.promote.studio.picker.makeSomething', defaultMessage: 'Make something' },
  addMaster: { id: 'app.sml.promote.studio.picker.addMaster', defaultMessage: 'Add the master' },
  songPage: { id: 'app.sml.promote.studio.picker.songPage', defaultMessage: 'Song page' },

  addTitle: { id: 'app.sml.promote.studio.picker.add.title', defaultMessage: 'An unreleased song' },
  addBody: {
    id: 'app.sml.promote.studio.picker.add.body',
    defaultMessage:
      'The title and the release date are enough. Add the master and the lyrics later, also from your phone.',
  },

  emptyStill: { id: 'app.sml.promote.studio.picker.empty.still', defaultMessage: 'Song' },
  emptyTitle: { id: 'app.sml.promote.studio.picker.empty.title', defaultMessage: 'Add a song to start' },
  emptyBody: {
    id: 'app.sml.promote.studio.picker.empty.body',
    defaultMessage:
      'The Studio makes stories, reels, Canvas loops and full videos for one song at a time. Add an unreleased song, or claim one that is already out.',
  },
  emptyAdd: { id: 'app.sml.promote.studio.picker.empty.add', defaultMessage: 'An unreleased song' },
  emptyClaim: { id: 'app.sml.promote.studio.picker.empty.claim', defaultMessage: 'Claim a released song' },
  emptyNote: {
    id: 'app.sml.promote.studio.picker.empty.note',
    defaultMessage: 'The title and the date are enough. Add the master later.',
  },
});
